export default {
    darkBlockColor      : '#1e2329',
    blockColor          : '#21252b',
    subBlockColor       : '#2b313a',
    underBlockColor     : '#474d57',
    warnColor           : '#d1a319',
    indicatorsColor     : '#21252b',
    indicatorColorAccent: '#2b313a',
    shadowDefault       : '#5e6572',
};
